import { InjectionToken } from '@angular/core';

import { DialogConfig } from '../models/dialog-config.model';

export const DIALOG_CONFIG = new InjectionToken<DialogConfig>('DIALOG_CONFIG');
